export default __webpack_public_path__ + "static/media/ui_unlock.5a88511b.ogg";